export const translations = {
  en: {
    appTitle: 'Rikken Score Tracker',
    startNewGame: 'Start New Game',
    continueGame: 'Continue Game',
    history: 'Game History',
    back: 'Back',
    menu: 'Menu',
    enterPlayerNames: 'Enter Player Names',
    playerName: 'Player',
    name: 'Name',
    players: 'Players',
    startGame: 'Start Game',
    selectGameType: 'Select Game Type',
    selectInitiators: 'Select Initiators',
    selectMate: 'Select Mate',
    tricksWon: 'Tricks Won',
    gameWon: 'Game Won',
    gameLost: 'Game Lost',
    addRound: 'Add Round',
    currentScores: 'Current Scores',
    round: 'Round',
    gameType: 'Game Type',
    initiator: 'Initiator',
    mate: 'Mate',
    result: 'Result',
    points: 'Points',
    endGame: 'End Game',
    newGame: 'New Game',
    deleteGame: 'Delete Game',
    confirm: 'Confirm',
    cancel: 'Cancel',
    won: 'Won',
    lost: 'Lost',
    tricks: 'tricks',
    total: 'Total',
    player: 'Player',
    score: 'Score',
    date: 'Date',
    rounds: 'Rounds',
    completed: 'Completed',
    inProgress: 'In Progress',
    noGamesYet: 'No games played yet',
    rules: 'Rules',
    pointSystem: 'Point System',
    language: 'Language',
    showGraph: 'Show Graph',
    showList: 'Show List',
    playerState: 'Player State',
    neutral: 'Neutral',
    selectPlayerStates: 'Select Player States',
    clickToChangeState: 'Click to change state',
    mateLosesOnFailure: 'Mate also loses points on failure',
    mateLosesOnFailureDescription: 'Official rules: mate never loses points. With this option, mate also loses points on failure.',
    confirmEndGame: 'Are you sure you want to end this game?',
    confirmEndGameDescription: 'This action cannot be undone.',
    buyMeABeer: 'Buy me a beer',
    supportDeveloper: 'Support the developer',
    mainSponsor: 'Main sponsor:\nWageningse Rikvereniging'
  },
  nl: {
    appTitle: 'Rikken Score Tracker',
    startNewGame: 'Nieuw Spel',
    continueGame: 'Verder Spelen',
    history: 'Geschiedenis',
    back: 'Terug',
    menu: 'Menu',
    enterPlayerNames: 'Voer Spelersnamen In',
    playerName: 'Speler',
    name: 'Naam',
    players: 'Spelers',
    startGame: 'Start Spel',
    selectGameType: 'Kies Speltype',
    // selectInitiators: 'Kies Spelers',
    selectInitiators: '',
    selectMate: 'Kies Maat',
    tricksWon: 'Slagen Behaald',
    gameWon: 'Spel Gewonnen',
    gameLost: 'Spel Verloren',
    addRound: 'Ronde Toevoegen',
    currentScores: 'Huidige Scores',
    round: 'Ronde',
    gameType: 'Speltype',
    initiator: 'Initiatiefnemer',
    mate: 'Maat',
    result: 'Resultaat',
    points: 'Punten',
    endGame: 'Spel Beëindigen',
    newGame: 'Nieuw Spel',
    deleteGame: 'Spel Verwijderen',
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
    won: 'Gewonnen',
    lost: 'Verloren',
    tricks: 'slagen',
    total: 'Totaal',
    player: 'Speler',
    score: 'Score',
    date: 'Datum',
    rounds: 'Rondes',
    completed: 'Voltooid',
    inProgress: 'Bezig',
    noGamesYet: 'Nog geen spellen gespeeld',
    rules: 'Regels',
    pointSystem: 'Puntensysteem',
    language: 'Taal',
    showGraph: 'Toon Grafiek',
    showList: 'Toon Lijst',
    playerState: 'Speler Status',
    neutral: 'Neutraal',
    selectPlayerStates: 'Selecteer Speler Statussen',
    clickToChangeState: 'Klik om status te wijzigen',
    mateLosesOnFailure: 'Maat verliest ook punten bij falen',
    mateLosesOnFailureDescription: 'Officiële regels: maat verliest nooit punten. Met deze optie verliest de maat ook punten bij falen.',
    confirmEndGame: 'Weet je zeker dat je dit spel wil beëindigen?',
    confirmEndGameDescription: 'Deze actie kan niet ongedaan worden gemaakt.',
    buyMeABeer: 'Koop een biertje voor Rikker Pim',
    supportDeveloper: 'Ondersteun de ontwikkelaar',
    mainSponsor: 'Hoofdsponsor:<br />Wageningse Rikvereniging'
  }
};
